function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginUser(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 24 24",
    width: 23,
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "user",
    d: "M18.58,15.57c-0.06-0.53-0.17-1.06-0.32-1.57c-0.14-0.48-0.34-0.94-0.61-1.36c-0.25-0.38-0.6-0.7-1-0.93  c-0.43-0.25-0.91-0.37-1.4-0.36c-0.86,0.86-2.03,1.34-3.24,1.32c-1.22,0.02-2.4-0.46-3.26-1.33c-0.49-0.01-0.97,0.11-1.4,0.36  c-0.4,0.23-0.75,0.55-1,0.93C6.09,13.06,5.89,13.52,5.76,14c-0.16,0.52-0.27,1.04-0.33,1.58c-0.06,0.55-0.09,1.11-0.09,1.67  c-0.01,0.7,0.23,1.38,0.67,1.93c0.36,0.5,0.93,0.8,1.55,0.82h8.89c0.62-0.02,1.19-0.32,1.56-0.82c0.44-0.55,0.67-1.24,0.65-1.95  C18.66,16.68,18.64,16.12,18.58,15.57z M14.84,5.18C14.1,4.41,13.08,3.98,12.01,4c-1.07-0.02-2.09,0.41-2.83,1.18  C8.42,5.92,7.99,6.94,8.01,8c-0.02,1.06,0.41,2.09,1.17,2.83c0.74,0.76,1.77,1.19,2.83,1.17c1.06,0.02,2.09-0.41,2.83-1.17  c0.76-0.74,1.19-1.77,1.17-2.83C16.02,6.94,15.6,5.92,14.84,5.18z",
    style: {
      fill: "rgb(69, 69, 69)"
    },
    vectorEffect: "non-scaling-stroke"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginUser);
export default __webpack_public_path__ + "static/media/login_user.34c41fb8.svg";
export { ForwardRef as ReactComponent };